import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute top-0 left-0 w-64 h-64 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path d="M 20 100 Q 60 20, 100 100 T 180 100" stroke="currentColor" fill="none" strokeWidth="2" />
          <path d="M 20 120 Q 60 40, 100 120 T 180 120" stroke="currentColor" fill="none" strokeWidth="2" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-8 relative">
        {/* Top Section */}
        <div className="mb-20">
          <div className="inline-block bg-purple-200/20 text-purple-200 px-4 py-2 rounded-lg text-sm mb-6">
            / 会社情報
          </div>
          <h2 className="text-5xl font-bold leading-tight mb-8 max-w-2xl">
            30年の実績が<br />物語る信頼
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed max-w-2xl">
            1995年の創業以来、私たちは東京・神奈川エリアを中心に、お客様一人ひとりの理想の住まい探しをサポートしてまいりました。豊富な経験と確かな実績で、安心・安全な不動産取引をお約束いたします。
          </p>
        </div>

        {/* Bottom Section */}
        <div className="flex items-center gap-12">
          {/* Left Image */}
          <div className="w-96 h-96 rounded-xl overflow-hidden shadow-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20modern%20Japanese%20real%20estate%20office%20interior%20with%20professional%20staff%20working%20at%20desks%2C%20bright%20natural%20lighting%20through%20large%20windows%2C%20contemporary%20minimalist%20design%20with%20wooden%20accents%20and%20plants%2C%20welcoming%20atmosphere%20with%20clean%20lines%20and%20sophisticated%20furniture%20arrangement%2C%20business%20professional%20environment&width=800&height=800&seq=about-002&orientation=squarish"
              alt="会社ビル外観"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right Content */}
          <div className="flex-1">
            <div className="mb-8">
              <p className="text-8xl font-serif font-bold mb-4">10,000+</p>
              <p className="text-xl text-slate-300 leading-relaxed">
                累計取引実績<br />
                (2024年12月現在)
              </p>
            </div>
            <button
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-slate-900 rounded-full hover:bg-slate-100 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              会社概要を見る
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
